import { fetchRequestPrev } from "@providers/conect_prev";

const verJornadasApi = async ( data ) => {

  try {
    const url = `integrations/previplan/consultar-franja-horaria`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const verJornadasHorariosApi = async ( data ) => {

  try {
    const url = `dgh/hora-turno-medico`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verJornadasApi, verJornadasHorariosApi };
